import request from '@/utils/request'

// 不需要鉴权列表
export function getNoAuthQuickList(params) {
  return request({
    url: '/admin/v1/no_auth/quick_bi/list',
    method: 'GET',
    params
  })
}

// quick_bi 列表
export function getQuickBiList(params){
  return request({
    url: '/admin/v1/quick_bi/list',
    method: 'GET',
    params
  })
}

// quick_bi 创建
export function quickBiCreate(params){
  return request({
    url: '/admin/v1/quick_bi/create',
    method: 'POST',
    data:params
  })
}

// quick_bi 更新
export function quickBiUpdate(params){
  return request({
    url: '/admin/v1/quick_bi/update',
    method: 'POST',
    data:params
  })
}

// quick_bi 详情
export function quickBiDetail(params){
  return request({
    url: '/admin/v1/quick_bi/detail',
    method: 'GET',
    params
  })
}
